import "./Lyrics.css";

import * as React from "react";
import Einhorn from "./Lyrics/Einhorn";
import Gorilla from "./Lyrics/Gorilla";

interface IText {
    title: string;
    content: {
        imageFileName?: string;
        component?: JSX.Element
    };
}

interface ILyricsProps {}

interface ILyricsState {
    chosenText: IText;
}

export default class Lyrics extends React.Component<ILyricsProps, ILyricsState> {

    private texte: Array<IText> = [
        {
            title: "Einhorn",
            content: {
                component: <Einhorn />
            }
        },
        {
            title: "Wenn du mir fehlst",
            content: {
                imageFileName: "wenn_du_mir_fehlst.png",
            }
        },
        {
            title: "Glas",
            content: {
                imageFileName: "glas.gif",
            }
        },
        {
            title: "Schmetterlingsphobie",
            content: {
                imageFileName: "schmetterlingsphobie.png",
            }
        },
        {
            title: "Gorilla",
            content: {
                component: <Gorilla />
            }
        }
    ];

    public constructor(props: ILyricsProps) {
        super(props);

        this.state = {
            chosenText: this.texte[0]
        };
    }

    public render() {

        const chosenText = this.state.chosenText;

        return (
            <div className="Lyrics">
                <div className="Lyrics__textLinks">
                    {this.texte.map((text, index) => {
                        const isChosen = this.state.chosenText === text;

                        return (
                            <span key={text.title}>
                                <a
                                    className={"Lyrics__textLink " + (isChosen ? "Lyrics__textLink--chosen" : "")}
                                    onClick={() => this.setState({ chosenText: text })}
                                >
                                    {text.title}
                                </a>
                                {index === this.texte.length - 1 ? null : " | "}
                            </span>
                        );
                    })}
                </div>

                <div className="Lyrics__content">
                    {chosenText.content.imageFileName && (
                        <img src={"assets/lyrics/" + chosenText.content.imageFileName} />
                    )}

                    {chosenText.content.component}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Lyrics.tsx